import * as types from '../const/action.types';
import { get, post, put, del } from '../api/_basic';
import { loadBasicInfo } from './session.actions';

export function loadRoles() {
    return async (dispatch) => {
        dispatch(rolesHasErrored(false, ''));
        dispatch(rolesIsLoading(true));
        dispatch(loadBasicInfo());
        return get(`${process.env.REACT_APP_API_ROL}`)
            .then((response) => {
                dispatch(rolesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(rolesHasErrored(false, ''));
                dispatch(loadRolesSuccess(items));
            })
            .catch((error) => {
                dispatch(rolesIsLoading(false));
                dispatch(rolesHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function loadAppRoles() {
    return async (dispatch) => {
        dispatch(rolesHasErrored(false, ''));
        dispatch(rolesIsLoading(true));
        return get(`${process.env.REACT_APP_API_ROLES}/aplicacion`)
            .then((response) => {
                dispatch(rolesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(rolesHasErrored(false, ''));
                dispatch(loadAppRolesSuccess(items));
            })
            .catch((error) => {
                dispatch(rolesIsLoading(false));
                dispatch(rolesHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function addRole(role) {
    return async (dispatch) => {
        dispatch(rolesIsLoading(true));
        return post(`${process.env.REACT_APP_API_ROL}`, role)
            .then((response) => {
                dispatch(rolesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(loadBasicInfo());
                dispatch(loadRoles());
                return true;
            })
            .catch((error) => {
                dispatch(rolesIsLoading(false));
                console.log(error);
                throw error;
            });
    };
}

export function cloneRoles(client) {
    return async (dispatch) => {
        dispatch(rolesIsLoading(true));
        return post(`${process.env.REACT_APP_API}/rolclonar/${client}`, {})
            .then((response) => {
                dispatch(rolesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(loadBasicInfo());
                dispatch(loadRoles());
                return true;
            })
            .catch((error) => {
                console.log(error);
                dispatch(rolesIsLoading(false));
                throw error;
            });
    };
}

export function editRole(role) {
    return async (dispatch) => {
        dispatch(rolesIsLoading(true));
        return put(`${process.env.REACT_APP_API_ROL}/${role.id}`, role)
            .then((response) => {
                dispatch(rolesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response.data;
            })
            .then((items) => {
                dispatch(loadBasicInfo());
                dispatch(loadRoles());
                return true;
            })
            .catch((error) => {
                console.log(error);
                dispatch(rolesIsLoading(false));
                throw error;
            });
    };
}

export function deleteRole(role) {
    return async (dispatch) => {
        return del(`${process.env.REACT_APP_API_ROL}/${role}`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                dispatch(loadRoles());
                return response;
            })
            .catch((error) => {
                console.log(error);
                dispatch(rolesIsLoading(false));
                throw error;
            });
    };
}

export function loadInfo(role) {
    return async function(dispatch) {
        dispatch(rolesHasErrored(false, ''));
        dispatch(rolesIsLoading(true));

        if (!role) {
            dispatch(
                loadRoleSuccess({
                    descripcion: '',
                    id: undefined,
                    nivel: 10,
                    nombre: '',
                    subroles: [],
                }),
            );
            return true;
        }
        return get(`${process.env.REACT_APP_API_ROL}/${role}`)
            .then((response) => {
                dispatch(rolesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((item) => {
                dispatch(rolesHasErrored(false, ''));
                dispatch(loadRoleSuccess(item));
            })
            .catch((error) => {
                //throw error;
                dispatch(rolesHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function loadAppRolesSuccess(data) {
    return {
        type: types.LOAD_APP_ROLES_SUCCESS,
        data,
    };
}

export function loadRoleSuccess(data) {
    return {
        type: types.LOAD_ROLE_SUCCESS,
        data,
    };
}

export function loadRolesSuccess(data) {
    return {
        type: types.ROLES_SUCCESS,
        data,
    };
}

export function rolesHasErrored(bool, message) {
    return {
        type: types.ROLES_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function rolesIsLoading(bool) {
    return {
        type: types.ROLES_IS_LOADING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/role.actions.js